// Import Firebase functions (modular approach)

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported  } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAJA06iHf_Iuok354OYLyAKZ2MI-fJgyE4",
  authDomain: "actions2service.firebaseapp.com",
  projectId: "actions2service",
  storageBucket: "actions2service.firebasestorage.app",
  messagingSenderId: "6259685911",
  appId: "1:6259685911:web:0bff1d4e08179a18ab7a52"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let _memo;

export async function getMessagingSafe() {
  if (_memo) return _memo;
  const supported = await isSupported();
  if (!supported) throw new Error("Messaging not supported (likely insecure context).");
  _memo = getMessaging(app);
  return _memo;
}

export { getToken };